<div mat-dialog-title class="options-library-picker__header">
  <h2>Options Library</h2>
  <button mat-icon-button title="Close Dialog" class="mat-dialog-title__close" (click)="onClose()">
    <fa-icon [icon]="faClose"></fa-icon>
  </button>
</div>

<div mat-dialog-content class="mat-typography options-library-picker__content">
  <mat-tab-group [disablePagination]="true" [selectedIndex]="selectedTab$()" (selectedIndexChange)="onTabChange($event)">
    <mat-tab ariaLabel="Browse from Library">
      <ng-template mat-tab-label>
        <span class="fs__sm fw__600">Browse from Library</span>
      </ng-template>

      @if (loadingOptionsSets$()) {
        <div class="options-library-picker__content__loading">
          <div class="options-library-picker__content__loading-content">
            <mat-spinner diameter="40"></mat-spinner>
            <span class="fs__lg">Loading Options Sets</span>
          </div>
        </div>
      } @else {
        <empathy-options-library-set
          [optionSets]="optionsSets$()"
          (selected)="selectedSet$.set($event)"
          (delete)="onDeleteOptionsSet($event)"
          (duplicate)="onDuplicateOptionsSet($event)"
          (edit)="onEditOptionsSet($event)"
        ></empathy-options-library-set>
      }
    </mat-tab>

    <mat-tab ariaLabel="Create new set">
      <ng-template mat-tab-label>
        <span class="fs__sm fw__600">Create new set</span>
      </ng-template>

      <empathy-options-library-form
        [optionSetForm]="optionSetForm$()"
        (create)="onFormatOptionSet(false)"
        (edit)="onFormatOptionSet(true)"
      ></empathy-options-library-form>
    </mat-tab>
  </mat-tab-group>
</div>

<div mat-dialog-actions>
  <button mat-stroked-button color="light" (click)="onClose()">Close</button>

  @if (selectedTab$() === LibrarySetTab) {
    <button mat-flat-button color="primary" [disabled]="!selectedSet$()" (click)="onCloseWithOptionsSet()">
      <span class="fs__sm fw__500">Add Option/s</span>
    </button>
  }
</div>
